const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';

function isCascadeRevealElement(element) {
  return (
    element.classList.contains('animate--fade-in') ||
    element.classList.contains('animate--slide-in')
  );
}

function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const target = entry.target;

    if (entry.isIntersecting) {
      if (target.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (target.hasAttribute('data-cascade')) {
          target.setAttribute('style', `--animation-order: ${index};`);
        }
      }
      if (isCascadeRevealElement(target)) {
        observer.unobserve(target);
      }
    } else {
      target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  );

  if (animationTriggerElements.length === 0) {
    return;
  }

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    });
    return;
  }

  animationTriggerElements.forEach((element) => {
    element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
  });

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px',
    threshold: 0.1,
  });

  animationTriggerElements.forEach((element) => {
    observer.observe(element);
  });
}


function scrollAnimationPercentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  return Math.round(distance / ((viewportHeight + elementHeight) / 100));
}

function scrollAnimationThrottle(fn, delay = 50) {
  let waiting = false;
  return (...args) => {
    if (waiting) return;
    fn(...args);
    waiting = true;
    setTimeout(() => {
      waiting = false;
    }, delay);
  };
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(
    document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
  );

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty(
      '--zoom-in-ratio',
      1 + scaleAmount * scrollAnimationPercentageSeen(element)
    );

    window.addEventListener(
      'scroll',
      scrollAnimationThrottle(() => {
        if (!elementIsVisible) return;
        element.style.setProperty(
          '--zoom-in-ratio',
          1 + scaleAmount * scrollAnimationPercentageSeen(element)
        );
      }),
      { passive: true }
    );
  });
}

function runScrollAnimationInit() {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(runScrollAnimationInit, 100);
  });
} else {
  setTimeout(runScrollAnimationInit, 100);
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeScrollAnimationTrigger(event.target, true);
  });
  document.addEventListener('shopify:section:reorder', () => {
    initializeScrollAnimationTrigger(document, true);
  });
}

window.reinitScrollAnimations = initializeScrollAnimationTrigger;